module.exports = __webpack_public_path__ + "static/media/blackbanana.2e0ad001.jpg";